import { useMutation } from '@apollo/client';
import TASK_TOGGLE_PHOTO_REQUIRED from '../gql/taskTogglePhotoRequired.graphql';

import toast from 'helpers/toast';
import { getGqlErrors } from 'components/projects/taskList/helpers';
import { translate } from 'javascripts/translations/i18n';

const useTaskTogglePhotoRequired = ({ taskId, onError = () => {} }) => {
  const showErrorToast = (errorMsg) => {
    toast.error(
      errorMsg ||
        translate('projects.taskList.templates.error.toggleRequirePhoto'),
    );
  };

  const [togglePhotoRequired, { loading }] = useMutation(
    TASK_TOGGLE_PHOTO_REQUIRED,
    {
      variables: {
        input: { id: taskId },
      },
      onCompleted: (data) => {
        const gqlErrors = getGqlErrors(data);

        if (gqlErrors.length) {
          showErrorToast(gqlErrors[0].message);
          onError();
        }
      },
      onError: () => {
        showErrorToast();
        onError();
      },
    },
  );

  return {
    togglePhotoRequired,
    loading,
  };
};

export default useTaskTogglePhotoRequired;
